module.exports = __webpack_public_path__ + "public/media/developer-left.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer-left.png
// module id = ./images/services/developer-left.png
// module chunks = 0